// extracted by mini-css-extract-plugin
module.exports = {"article":"index-module--article--2ALAK","title":"index-module--title--oP42u","link":"index-module--link--3FB9A"};